<script>
  /* eslint-disable no-use-before-define */
  import Credit from './credit.svelte'
  import Picture from '../picture.svelte'

  export let data
  const { mediaInfo, text, showCredit } = data
  export let showText = true

  export let leanTowards = 'left'
  const useText = text && showText
  const frameClass = `pictureframe lean-${leanTowards}${!useText ? ' no-text' : ''}`
</script>

<div class={frameClass}>
  <Picture {mediaInfo} />
  {#if useText}
    <p class="caption">{text}</p>
  {/if}
  {#if showCredit}
    <div class="credit-wrapper">
      <Credit
        category={mediaInfo.category}
        creators={mediaInfo.creators}
        credit={mediaInfo.credit}
      />
    </div>
  {/if}
</div>

<style>
  .pictureframe {
    display: inline-block;
    width: 85%;
    padding: 18.5px 18.5px 0 18.5px;
    background-color: #061629;
    max-width: 380px;
    /* margin-bottom: 100px; */
    margin-top: 10px;
    margin-bottom: 10px;
    z-index: 0;

    @media screen and (min-width: 600px) {
      width: 100%;
    }
  }

  .pictureframe.no-text {
    padding: 18.5px 18.5px 62px 18.5px;
  }
  .pictureframe.lean-left {
    transform: rotate(-3deg);
  }

  .pictureframe.lean-right {
    transform: rotate(3deg);
  }

  .credit-wrapper {
    position: absolute;
    top: -10px;
    right: -10px;
    transform: rotate(-90deg);
    transform-origin: right;
  }

  .caption {
    color: #fafafa;
    text-align: center;
  }
</style>
